import { inject, injectable } from "@launchtray/tsyringe-async";
import { PromiseCompletionSource, Viewable } from "scene-manager";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { InjectableInterfaces } from "../../../composition/InjectableInterfaces";
import { LoseView } from "./views/LoseView";
import { LoseSceneResult } from "./LoseSceneResult";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { LoseResourcesPackage } from "./resources/LoseResourcesPackage";
import { LocalizationModel } from "../../../common/models/LocalizationModel";
import { LoseSceneOptions } from "./LoseSceneOptions";
import { LosePopupController } from "./controllers/LosePopupController";

@injectable()
export class LoseScene extends Viewable<LoseSceneResult> {
    public constructor(
        commonResources: CommonResourcesPackage,
        loseResources: LoseResourcesPackage,
        localizationModel: LocalizationModel,
        loseController: LosePopupController,
        @inject(InjectableInterfaces.LoseSceneOptions)
        options: LoseSceneOptions,
        @inject(InjectableInterfaces.ICanvasScaler)
        canvasScaler: ICanvasScaler
    ) {
        super();
        const pcs = new PromiseCompletionSource<LoseSceneResult>();
        this.view = new LoseView(
            commonResources, 
            loseResources, 
            localizationModel,
            loseController,
            options.type,
            options.vegetablesForAd,
            canvasScaler, 
            pcs
        );
        pcs.result.then(
            (result: LoseSceneResult) => this.operationControls.complete(result),
            (reason: unknown) => this.operationControls.error(reason)
        );
    }
}
